import React, {Fragment} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "./featureInterface";
import FeaturesSetupFeatureThumbnail from "./FeaturesSetupFeatureThumbnail";
import FeaturesSetupFeatureContent from "./FeaturesSetupFeatureContent";
import FeaturesSetupFeatureSelectedCheckbox from "./FeaturesSetupFeatureSelectedCheckbox";
import FeaturesSetupFeatureActionsTop from "./FeaturesSetupFeatureActionsTop";
import FeaturesSetupFeatureActionsBottom from "./FeaturesSetupFeatureActionsBottom";
import FeaturesSetupFeatureContentCostAndShipping from "./FeaturesSetupFeatureContentCostAndShipping";
import {FEATURES_CONTENT_TYPES} from "../featuresReducer";
import FeaturesSetupFeatureContentToolSettings from "./FeaturesSetupFeatureContentToolSettings";


const FeaturesSetupFeature = (props) => {

  const {feature, featuresContentType, isOldToolVersionFeature, pendingFeatures} = props;

  if (!feature) {
    return null
  }

  const getContent = () => {
    switch (featuresContentType) {
      case FEATURES_CONTENT_TYPES.costAndShippingType:
        return <FeaturesSetupFeatureContentCostAndShipping feature={feature}/>
      case FEATURES_CONTENT_TYPES.toolSettingsType:
        return <FeaturesSetupFeatureContentToolSettings feature={feature}/>
      default:
        return (
          <Fragment>
            <FeaturesSetupFeatureContent feature={feature}/>
            <div className="wizard-item__box fs-feature__actions">
              <FeaturesSetupFeatureActionsTop feature={feature}/>
              <FeaturesSetupFeatureActionsBottom feature={feature}/>
            </div>
          </Fragment>
        )
    }
  }

  return (
    <div className={"wizard-item fs-feature" + (isOldToolVersionFeature ? " wizard-item--red" : "")
      + (pendingFeatures[feature.featureDefinitionId] ? " wizard-item--updated" : "")}>
      <div className="wizard-item__box fs-feature__box">
        <FeaturesSetupFeatureThumbnail feature={feature} />
        {feature.pricingProfileIcon && !feature.pricingProfileName
          ? <div className="assign-card__icon assign-card__icon--centered"
                 style={{backgroundImage: `url('${feature.pricingProfileIcon}'`}}/> : null}
        {feature.pricingProfileName ? <div className="assign-card__text">{feature.pricingProfileName}</div> : null}
        <FeaturesSetupFeatureSelectedCheckbox feature={feature}/>
      </div>
      {getContent()}
    </div>
  )
};

FeaturesSetupFeature.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store, ownProps) => {
  const {featuresContentType, pendingFeatures} = store.featuresSetupState;
  const {customerInfo} = store.newaccount;

  const isOldToolVersionFeature = ownProps.feature && ownProps.feature.toolVersion && customerInfo && customerInfo.toolSettings && (
      (ownProps.feature.toolVersion === "kv4" && customerInfo.toolSettings["kitchen"] && customerInfo.toolSettings["kitchen"].version === 5)
      || (ownProps.feature.toolVersion === "bv4" && customerInfo.toolSettings["bathroom"] && customerInfo.toolSettings["bathroom"].version > 4)
    );

  return {
    featuresContentType,
    isOldToolVersionFeature,
    pendingFeatures
  };
};

export default connect(mapStateToProps)(FeaturesSetupFeature)
